import { render, staticRenderFns } from "./CaseDetailCard.vue?vue&type=template&id=e9e3e53a"
import script from "./CaseDetailCard.vue?vue&type=script&lang=js"
export * from "./CaseDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports